import { all } from "redux-saga/effects";
import Product from "./product";
import User from "./user";
import Order from "./order";
import Category from "./category";
import File from "./file";
import Shipping from "./shipping";
import Coupon from "./coupon";
import Log from "./log";
import ApiKey from "./api-key";
import Subscription from "./subscription";
import Post from "./post";
import Contact from "./contact";
import Dealer from "./dealer";
import Payment from "./payment";
import Gallery from "./gallery";
import RenderedImage from "./renderedimage";
import Setting from "./setting";
import Stats from "./stats";
import Role from "./role";
import Affiliates from "./affiliate";
import EmailTemplate from "./emailtemplate";
import Faq from "./faq";
import Review from "./review";
import CartFunnel from "./cartfunnel";
import Campaign from "./campaign";
import Outreach from "./outreach";
import Quote from "./quote";
import RefundRequest from "./refund-request";
import Tracking from "./tracking";
import Notification from "./notification";

const sagas = function* sagas() {
  yield all([
    Product(),
    User(),
    Order(),
    Category(),
    File(),
    Shipping(),
    Coupon(),
    Log(),
    ApiKey(),
    Subscription(),
    Post(),
    Contact(),
    Dealer(),
    Payment(),
    Gallery(),
    RenderedImage(),
    Setting(),
    Stats(),
    Role(),
    Affiliates(),
    EmailTemplate(),
    Faq(),
    Review(),
    CartFunnel(),
    Campaign(),
    Outreach(),
    Quote(),
    RefundRequest(),
    Tracking(),
    Notification(),
  ]);
};

export default sagas;
